"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isString = void 0;
var isString = exports.isString = function isString(str) {
  return typeof str === 'string' || str instanceof String;
};